module.exports = __webpack_public_path__ + "static/media/cgplag-react-white.dc83cab5.png";